import React from 'react';

import {
  BannerActionConfig,
  ListBanner,
} from '@qality/common-components/src/molecules/ListBanner';

import { BannerContainer } from './DashboardListBanner.styled';

interface DashboardListBannerViewProps {
  title: string;
  items: Array<string>;
  primaryAction: BannerActionConfig;
  secondaryAction: BannerActionConfig;
  bannerImagePath: string;
}

export const DashboardListBannerView: React.FC<DashboardListBannerViewProps> =
  ({
    title,
    items,
    primaryAction,
    secondaryAction,
    bannerImagePath,
  }: DashboardListBannerViewProps) => {
    return (
      <BannerContainer>
        <ListBanner
          title={title}
          items={items}
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
          bannerImagePath={bannerImagePath}
        />
      </BannerContainer>
    );
  };
